import React from 'react';
import { ManuallyRemoveWorkers } from 'react-scale/components/ExpertManagement/ExpertManagementPage/CommunityManagement/ManuallyRemoveWorkers';

export const UserManagement: React.FC = () => {
  return (
    <div style={{ minWidth: '70%' }} className="flex flex-col gap-4">
      <ManuallyRemoveWorkers />
    </div>
  );
};
